// 詳細モーダル
// マークアップ: [data-mp-modal="key"]（オーバーレイ、hidden で閉じる）、起動: [data-mp-modal-open="key"]
//   閉じる: [data-mp-modal-close]、別モーダルへ: [data-mp-modal-go="key"]
// 開いている間は main に inert を付け、html にスクロールロックを付ける。Tab はダイアログ内で循環する。

const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
const LOCK_CLASS = 'is-scroll-locked';

export function setupModals() {
  const overlays = new Map([...document.querySelectorAll('[data-mp-modal]')].map((el) => [el.dataset.mpModal, el]));
  if (overlays.size === 0) return;

  const main = document.querySelector('main');
  let current = null;
  let returnFocus = null;

  const close = (restore = true) => {
    if (!current) return;
    current.hidden = true;
    current = null;
    document.documentElement.classList.remove(LOCK_CLASS);
    main?.removeAttribute('inert');
    if (restore && returnFocus) returnFocus.focus({ preventScroll: true });
  };

  const open = (key, trigger = null) => {
    const overlay = overlays.get(key);
    if (!overlay) return;
    if (current) current.hidden = true;
    if (trigger) returnFocus = trigger;
    current = overlay;
    overlay.hidden = false;
    document.documentElement.classList.add(LOCK_CLASS);
    main?.setAttribute('inert', '');
    requestAnimationFrame(() => overlay.querySelector('[role="dialog"]')?.focus({ preventScroll: true }));
  };

  document.querySelectorAll('[data-mp-modal-open]').forEach((trigger) => {
    trigger.addEventListener('click', () => open(trigger.dataset.mpModalOpen, trigger));
  });

  overlays.forEach((overlay) => {
    overlay.addEventListener('click', (event) => {
      if (event.target === overlay || event.target.closest('[data-mp-modal-close]')) {
        close();
        return;
      }
      const go = event.target.closest('[data-mp-modal-go]');
      if (go) open(go.dataset.mpModalGo);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (!current) return;
    if (event.key === 'Escape') {
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    const items = [...current.querySelectorAll(FOCUSABLE)].filter((el) => !el.hidden && el.getAttribute('aria-hidden') !== 'true' && el.offsetParent !== null);
    if (items.length === 0) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === current.querySelector('[role="dialog"]'))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
}
